var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWechat = function SvgWechat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 21",
    fill: "#851A92",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.928 14.794H12a6.881 6.881 0 0 0 6.87-6.49 4.818 4.818 0 0 1 .87 9.329v2.836l-3.99-2.58h-1.322a4.818 4.818 0 0 1-4.5-3.095Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.88C0 3.08 3.08 0 6.88 0h4.433a6.88 6.88 0 0 1 0 13.762H9.044l-4.753 3.096v-3.6A6.883 6.883 0 0 1 0 6.88Zm5.15 1.377c.758 0 1.373-.616 1.373-1.376 0-.76-.615-1.376-1.373-1.376-.759 0-1.374.616-1.374 1.376 0 .76.615 1.376 1.374 1.376Zm5.149-1.376a1.375 1.375 0 1 1-2.746 0c0-.76.614-1.376 1.372-1.376.759 0 1.373.616 1.373 1.376ZM12.7 8.257c.759 0 1.374-.616 1.374-1.376a1.375 1.375 0 1 0-2.746 0c0 .76.614 1.376 1.372 1.376Z"
  })));
};

export default SvgWechat;